import { createLocalStorageSync } from './use-local-storage-sync'

export type RecurringSortKey = 'day_of_month' | 'amount' | 'category' | 'paid_by'

const VALID_KEYS: RecurringSortKey[] = ['day_of_month', 'amount', 'category', 'paid_by']

export function validateRecurringSortKey(raw: string | null): RecurringSortKey | null {
  if (!raw) return null

  // Migrate from old format { key, direction }
  try {
    const parsed = JSON.parse(raw)
    if (typeof parsed === 'object' && parsed !== null && VALID_KEYS.includes(parsed.key)) {
      localStorage.setItem('recurring-sort', parsed.key as RecurringSortKey)
      return parsed.key as RecurringSortKey
    }
  } catch {
    // not object, try string
  }

  const cleaned = raw.replace(/"/g, '') as RecurringSortKey
  if (VALID_KEYS.includes(cleaned)) return cleaned

  return null
}

export const useRecurringSort = createLocalStorageSync<RecurringSortKey>(
  'recurring-sort',
  'day_of_month',
  validateRecurringSortKey,
)
